export default {
  automation: {
    menu: 'Automação',
  },
  billing: {
    menu: 'Financeiro',
    catalog: 'Financeiro',
  },
  contacts: {
    menu: 'Contatos',
    catalog: 'Contatos',
  },
  crm: {
    menu: 'CRM',
  },
  deals: {
    menu: 'Negócios',
  },
  configuration: {
    menu: 'Configurações',
  },
  access:{
    menu: 'Acesso'
  },
  catalog:{
    menu: 'Catálogo'
  },
  channels:{
    menu: 'Canais'
  },
  cms:{
    menu: 'Administrador de Sites'
  },
  commercial: {
    menu: 'Comercial'
  },
  domains:{
    catalog: 'Catálogo de Soluções',
    description: 'Controle de domínios para os produtos digitais da Nucleop, organizados por áreas de atuação e tipos de soluções, facilitando a navegação e descoberta de funcionalidades específicas.',
    menu: 'Domínios'
  },
  execution:{
    menu: 'Execução'
  },
  financial: {
    menu: 'Financeiro'
  },
  integration:{
    menu: 'Integração'
  },
  management: {
    menu: 'Gestão'
  },
  operations: {
    menu: 'Operações',
    catalog: 'Operações',
  },
  prospect:{
    menu: 'Prospecção Inteligente'
  },
  relationships:{
    menu: 'Relacionamentos',
  },
  scheduling: {
    menu: 'Agendamentos',
    catalog: 'Agendamentos',
  },
  serviceBoard: {
    menu: 'Boards',
    catalog: 'Boards',
  },
  sitemanager:{
    menu: 'Gerenciador de Sites'
  },
  tenancy:{
    menu: 'Gestão de Clientes'
  },
};
